import { page as landingPages } from '../../features/landingPageCss/landingPageCssFeature'
import { page as responsiveLayout } from '../../features/responsiveLayout/responsiveLayoutCssFeature'
import { page as variables } from '../../features/variables/variablesCssFeature'
import { page as styleBased } from '../../features/styleBased/styleBasedFeature'
import { page as screenIn } from '../../features/screenIn/screenInCssFeature'
import { page as canvas } from '../../features/canvas/canvasCssFeature'
import { page as motion } from '../../features/motionCss/motionCssFeature'
import { page as motionEffects } from '../../features/motionEffects/motionEffectsCssFeature'
import { page as transitions } from '../../features/transitions/transitionsCssFeature'
import { page as transformations } from '../../features/transformations/transformationsCssFeature'
import { page as accessibility } from '../../features/accessibilityStyle/accessibilityStyleCssFeature'
import { page as compsMeasures } from '../../features/compsMeasures/compsMeasuresCssFeature'
import { page as zIndex } from '../../features/zIndexCss/zIndexCssFeature'
import { page as mesh } from '../../features/mesh/meshCssFeature'
import { page as fontFaces } from '../../features/fontFaces/fontFacesFeature'
import { page as stylable } from '../../features/stylable/stylableFeature'
import { page as pinnedLayout } from '../../features/pinnedLayout/pinnedLayoutCssFeature'
import { page as presets } from '../../features/presets/presetsCssFeature'
import { page as cursor } from '../../features/cursor/cursorCssFeature'
import { page as compCssMappers } from '../../features/compCssMappers/compCssMappersFeature'
import { page as themeFontsAndColors } from '../../features/themeFontsAndColors/themeFontsAndColorsCssFeature'
import { page as imageXScrollEffects } from '../../features/imageXScrollEffects/imageXScrollEffectsCssFeature'
import { page as autoHeightWrapper } from '../../features/autoHeightWrapper/autoHeightWrapperCompNode'

export const PUBLIC_CSS_FEATURES = {
	landingPages,
	responsiveLayout,
	autoHeightWrapper,
	variables,
	styleBased,
	screenIn,
	canvas,
	motion,
	motionEffects,
	transitions,
	transformations,
	accessibility,
	compsMeasures,
	zIndex,
	mesh,
	fontFaces,
	stylable,
	pinnedLayout,
	presets,
	cursor,
	compCssMappers,
	themeFontsAndColors,
	imageXScrollEffects,
}

export const RESPONSIVE_MASTER_PAGE_CSS_FEATURES = {
	accessibility,
	fontFaces,
	themeFontsAndColors,
	compCssMappers,
	variables,
}
